import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/", label: "Accueil" },
    { href: "/voitures", label: "Nos Voitures" },
    { href: "/produits", label: "Nos Produits" },
    { href: "/services", label: "Services" },
    { href: "/a-propos", label: "À Propos" },
    { href: "/galerie", label: "Galerie" },
    { href: "/avis", label: "Avis" },
    { href: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header 
      className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-xl border-b border-gray-200 shadow-sm"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Ligne 1: Logo centré + Téléphone/RDV */}
        <div className="flex items-center justify-between h-20">
          {/* Espace vide à gauche pour équilibrer */}
          <div className="w-48 hidden lg:block"></div>

          {/* Logo centré */}
          <Link 
            to="/" 
            className="flex-shrink-0"
            data-testid="logo"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_5a4239fb-4bc2-4826-87e7-5a8922edf632/artifacts/sxfp077y_logo.jpg" 
              alt="ACICAR Logo" 
              className="h-20 w-auto"
            />
          </Link>

          {/* Téléphone en cadre jaune à droite */}
          <div className="hidden lg:flex items-center">
            <a 
              href="tel:0646634968" 
              className="flex items-center gap-2 bg-yellow-500 text-white px-6 py-3 rounded-lg font-bold hover:bg-yellow-600 transition-colors"
              data-testid="phone-link"
            >
              <Phone className="w-5 h-5" />
              <span>06 46 63 49 68</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-800"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Ligne 2: Navigation (Desktop) */}
        <nav className="hidden lg:flex items-center justify-center gap-8 h-12" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`nav-link ${isActive(link.href) ? "active" : ""}`}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Mobile Navigation */}
        {isOpen && (
          <div 
            className="lg:hidden py-4 border-t border-gray-200"
            data-testid="mobile-nav"
          >
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`nav-link py-2 ${isActive(link.href) ? "active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <a 
                href="tel:0646634968" 
                className="flex items-center justify-center gap-2 bg-yellow-500 text-white px-6 py-3 rounded-lg font-bold mt-4"
              >
                <Phone className="w-5 h-5" />
                <span>06 46 63 49 68</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
